import axios from 'axios';

const API_URL = '/api';

// Create axios instance
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Handle responses and errors
api.interceptors.response.use(
  (response) => response.data,
  (error) => {
    const err = error.response?.data || { error: error.message };
    err.status = error.response?.status;
    return Promise.reject(err);
  }
);

// Auth
export const authAPI = {
  signup: (clinicData) => api.post('/auth/signup', clinicData),
  login: (credentials) => api.post('/auth/login', credentials),
  register: (userData) => api.post('/auth/register', userData),
  getMe: () => api.get('/auth/me'),
  updateProfile: (data) => api.put('/auth/update-profile', data),
  changePassword: (data) => api.put('/auth/change-password', data),
  inviteUser: (data) => api.post('/auth/invite-user', data)
};

// Patients
export const patientsAPI = {
  getAll: (params) => api.get('/patients', { params }),
  getById: (id) => api.get(`/patients/${id}`),
  create: (data) => api.post('/patients', data),
  update: (id, data) => api.put(`/patients/${id}`, data),
  delete: (id) => api.delete(`/patients/${id}`),
  getHistory: (id) => api.get(`/patients/${id}/history`)
};

// Appointments
export const appointmentsAPI = {
  getAll: (params) => api.get('/appointments', { params }),
  getToday: () => api.get('/appointments/today'),
  getById: (id) => api.get(`/appointments/${id}`),
  create: (data) => api.post('/appointments', data),
  update: (id, data) => api.put(`/appointments/${id}`, data),
  updateStatus: (id, status) => api.put(`/appointments/${id}/status`, { status }),
  cancel: (id, reason) => api.put(`/appointments/${id}/cancel`, { reason }),
  delete: (id) => api.delete(`/appointments/${id}`)
};

// Clinical Notes
export const notesAPI = {
  getByPatient: (patientId) => api.get(`/notes/patient/${patientId}`),
  create: (data) => api.post('/notes', data),
  update: (id, data) => api.put(`/notes/${id}`, data)
};

// Invoices
export const invoicesAPI = {
  getAll: (params) => api.get('/invoices', { params }),
  getById: (id) => api.get(`/invoices/${id}`),
  create: (data) => api.post('/invoices', data),
  update: (id, data) => api.put(`/invoices/${id}`, data),
  getStats: () => api.get('/invoices/stats/revenue')
};

// Practitioners
export const practitionersAPI = {
  getAll: () => api.get('/practitioners')
};

// Clinic
export const clinicAPI = {
  getInfo: () => api.get('/clinic/info'),
  updateSettings: (data) => api.put('/clinic/settings', data),
  getSubscription: () => api.get('/clinic/subscription'),
  upgrade: (tier) => api.post('/clinic/upgrade', { tier }),
  getUsage: () => api.get('/clinic/usage')
};

export default api;
